/* One place for the business details shown across the storefront (header, footer, policy pages).
   Replace the placeholder contact details before going live. */
export const SITE = {
  name: 'Automotive Parts & Batteries',
  shortName: 'AutoParts',
  tagline: 'Car batteries and parts, delivered Australia-wide',
  country: 'Australia',
  currency: 'AUD',
  gstNote: 'All prices are in Australian dollars (AUD) and include GST unless stated.',
  phone: '1300 000 000',                 // placeholder: replace
  email: 'support@example.com.au',        // placeholder: replace
  abn: 'ABN 00 000 000 000',              // placeholder: replace
  legalName: 'Your Company Pty Ltd',      // placeholder: replace
  hours: ['Monday to Friday: 8:30 am to 5:30 pm', 'Saturday: 9:00 am to 1:00 pm', 'Sunday and public holidays: closed'],
  warehouses: [
    { name: 'Sydney', place: 'Castle Hill, NSW' },
    { name: 'Melbourne', place: 'Dingley Village, VIC' },
  ],
  lastUpdated: '3 November 2026',
};
export const STATES = ['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'];
export const HOME_CATEGORIES = [
  { name: 'Batteries', blurb: 'Car, 4WD and AGM start-stop', to: '/products?category=Batteries' },
  { name: 'Chargers & Jump Starters', blurb: 'Keep your battery healthy', to: '/products?category=Batteries&sub=Chargers%20%26%20Jump%20Starters' },
  { name: 'Servicing', blurb: 'Filters and engine oil', to: '/products?category=Servicing' },
  { name: 'Brakes & Suspension', blurb: 'Pads for everyday driving', to: '/products?category=Brakes%20%26%20Suspension' },
  { name: 'Lighting', blurb: 'Globes and LED lighting', to: '/products?category=Lighting' },
  { name: 'Electrical & Wipers', blurb: 'Spark plugs and wiper blades', to: '/products?category=Electrical%20%26%20Wipers' },
];
export const HOME_BRANDS = ['Century', 'Exide', 'Bosch', 'Varta', 'Ryco', 'Narva', 'Castrol', 'CTEK', 'Projecta'];
